import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router.js'
import store from './store.js'
import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/auth';

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyDgrGV1CKvT6TXbDXJ3tghLb-rMETADHLM",
  authDomain: "shopping-list-ce3b5.firebaseapp.com",
  databaseURL: "https://shopping-list-ce3b5.firebaseio.com",
  projectId: "shopping-list-ce3b5",
  storageBucket: "shopping-list-ce3b5.appspot.com",
  messagingSenderId: "915998660288",
  appId: "1:915998660288:web:77c4f10f7003f560a5bf25"
};

firebase.initializeApp(firebaseConfig);

Vue.prototype.$db = firebase.firestore();

let app = "";

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});